import styled from 'styled-components';
import { CloseIcon } from '@lt/components/components/ResponsiveModal/components/CloseIcon';
import React from 'react';

type Props = {
  onClick?(): void;
};

export const CloseButton = ({ onClick }: Props) => (
  <Wrapper onClick={onClick} type="button">
    <CloseIcon width={24} height={24} />
  </Wrapper>
);

const Wrapper = styled.button`
  position: absolute;
  top: 0;
  right: 0;
  z-index: 1;
  color: rgb(145, 148, 153);
  outline: none;
  border: none;
  background-color: transparent;
  padding: 0;
  width: 25px;
  height: 25px;
  cursor: pointer;
`;
